module.exports = __webpack_public_path__ + "img/i_main_icon_03.9c4674f7.svg";